import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { XCircleIcon } from '@heroicons/react/24/outline';
import Button from '@/components/UI/Button';
import Modal from '@/components/UI/Modal';
import { PdfjsExpressViewer } from '@/features/projects/components/Reports/PdfViewer';

interface PreviewModalProps {
  fileUrl: string;
  title: string;
}

export const PreviewModal = NiceModal.create(({ fileUrl, title }: PreviewModalProps) => {
  const modal = useModal();

  if (!modal.visible) return null;

  return (
    <Modal customStyle='max-w-full'>
      <div className='flex justify-between mb-2'>
        <p>{title}</p>
        <Button
          btnStyle='btn-neutral'
          btnSize='btn-sm'
          icon={<XCircleIcon />}
          onClick={() => {
            modal.hide();
          }}
        />
      </div>
      <PdfjsExpressViewer src={fileUrl} />
    </Modal>
  );
});
